import { render, staticRenderFns } from "./btnsCircle.vue?vue&type=template&id=8dd02db0&scoped=true&"
import script from "./btnsCircle.vue?vue&type=script&lang=js&"
export * from "./btnsCircle.vue?vue&type=script&lang=js&"
import style0 from "./btnsCircle.vue?vue&type=style&index=0&id=8dd02db0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd02db0",
  null
  
)

export default component.exports